export const TooltipType = {
  WARNING: 'WARNING',
};
